"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _logo = _interopRequireDefault(require("../logo"));

var _paragraph = _interopRequireDefault(require("../paragraph"));

var _footerSection = _interopRequireDefault(require("./footer-section"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var SiteFooter = function SiteFooter(_ref) {
  var _classNames;

  var className = _ref.className,
      colour = _ref.colour,
      content = _ref.content,
      links = _ref.links,
      showAngle = _ref.showAngle;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: (0, _classnames.default)(_indexModule.default.SiteFooter, className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _indexModule.default.showAngle, showAngle), (0, _defineProperty2.default)(_classNames, _indexModule.default.seasonal, showAngle && colour === 'seasonal'), (0, _defineProperty2.default)(_classNames, _indexModule.default.brand, showAngle && colour === 'brand'), _classNames)),
    role: "contentinfo"
  }, /*#__PURE__*/_react.default.createElement(_container.default, {
    className: _indexModule.default.container,
    type: "large"
  }, content && /*#__PURE__*/_react.default.createElement(_footerSection.default, null, content), /*#__PURE__*/_react.default.createElement(_footerSection.default, {
    className: _indexModule.default.linksSection
  }, /*#__PURE__*/_react.default.createElement(_logo.default, {
    type: "alt",
    className: _indexModule.default.logo
  }), /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    className: _indexModule.default.responsibleBusinessSection
  }, "Scentre Group operates its Westfield Living Centre portfolio with a responsible business mindset across the four pillars of community, people, environment and economic performance. More information can be found in our", ' ', /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)(_indexModule.default.footerLink, _indexModule.default.rightsTextLink),
    href: "https://www.scentregroup.com/getmedia/6bf752b0-bc41-4d63-8d50-3790d9c1a5f7/2020-Responsible-Business-Report.pdf?ext=.pdf"
  }, "2020 Responsible Business Report"), "."), /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.linksWrapper
  }, links && /*#__PURE__*/_react.default.createElement("ul", {
    className: _indexModule.default.linksList
  }, links.map(function (_ref2) {
    var label = _ref2.label,
        href = _ref2.href;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: href
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: href,
      className: _indexModule.default.footerLink
    }, label));
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: _indexModule.default.rightsText
  }, /*#__PURE__*/_react.default.createElement("span", null, "\xA9 All rights reserved."), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.scentregroup.com",
    className: (0, _classnames.default)(_indexModule.default.footerLink, _indexModule.default.rightsTextLink)
  }, "Scentre Group"), /*#__PURE__*/_react.default.createElement("span", null, new Date().getFullYear()))))));
};

SiteFooter.propTypes = {
  className: _propTypes.string,
  showAngle: _propTypes.bool,
  colour: (0, _propTypes.oneOf)(['brand', 'seasonal']),
  content: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]),
  links: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    href: _propTypes.string.isRequired
  }))
};
SiteFooter.defaultProps = {
  className: null,
  showAngle: true,
  colour: 'seasonal',
  links: []
};
var _default = SiteFooter;
exports.default = _default;